<template>
    <div class="orders-layout" >
        <div class="row" >
            <div class="col-md-12 mb-4">
                <table class="table table-order mb-3">
                    <tbody>
                        <tr><td class="order-details-label">Order Date:</td> <td class="order-detail">{{ __(orderData.order_date, ['date']) }}</td></tr>
                        <tr><td class="order-details-label">Client Name:</td> <td class="order-detail">{{ __(clientName, ['titleCase']) }}</td></tr>
                        <!-- <tr><td class="order-details-label">Customer Type:</td> <td class="order-detail">{{ _.get(orderData, 'customer_type', '___') }}</td></tr> -->
                        <tr><td class="order-details-label">Phone:</td> <td class="order-detail">{{ _.get(orderData, 'phone', '___') }}</td></tr>
                        <!-- <tr><td class="order-details-label">Mobile:</td> <td class="order-detail">{{ _.get(orderData, 'customer.mobile', '___') }}</td></tr> -->
                        <tr><td class="order-details-label">Email:</td> <td class="order-detail">{{ _.get(orderData, 'email', '___') }}</td></tr>
                        <!-- <tr><td class="order-details-label">Order Total:</td> <td class="order-detail">${{ orderData.order_total || 0 }}</td></tr> -->
                        <!-- <tr><td class="order-details-label">Freight Total:</td> <td class="order-detail">${{ orderData.freight_total || 0 }}</td></tr> -->
                        <!-- <tr><td class="order-details-label">Amount Billed:</td> <td class="order-detail">${{ orderData.amount_billed || 0 }}</td></tr> -->
                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <address>
                    <h3 class="table-heading">Billed To:</h3>
                    <table class="table table-order">
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{{ __(clientName, ['titleCase']) }}</td>
                            </tr>
                            <tr>
                                <td class="vert-top">Address</td>
                                <td>{{ orderData.b_address1 || orderData.b_street || '___' }}<br>
                                    {{ orderData.b_address2 || '___' }}<br>
                                    {{ orderData.b_suburb || '___' }}<br>
                                    {{ orderData.b_city || '___' }}<br>
                                    {{ orderData.b_country || '___' }}<br>
                                    {{ orderData.b_postcode || '___' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                </address>
            </div>
            <div class="col-md-6">
                <h3 class="table-heading">Shipped To:</h3>
                <table class="table table-order">
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>{{ __(clientName, ['titleCase']) }}</td>
                        </tr>
                        <tr>
                            <td class="vert-top">Address</td>
                            <td>
                                {{ orderData.s_address1 || orderData.s_street || '___' }}<br>
                                {{ orderData.s_address2 || '___' }}<br>
                                {{ orderData.s_suburb || '___' }}<br>
                                {{ orderData.s_city || '___' }}<br>
                                {{ orderData.s_country || '___' }}<br>
                                {{ orderData.s_postcode || '___' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row" >
            <div class="col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h3 class="table-heading">Order summary</h3>
                    </div>
                    <div v-if="_.isEmpty(customOrderData)" class="alert alert-secondary">
                        No information
                    </div>
                    <div v-else class="panel-body">
                        <div class="table-responsive">
                            <table class="table table-order">
                                <tbody>
                                    <tr><td>Order Type</td>
                                        <td>{{ orderData.order_type }}</td>
                                    </tr>
                                    <!-- foreach ($order->lineItems as $line) or some such thing here -->
                                    <tr v-for="(value, key) in customOrderData" :key="key">
                                        <td style="width: 30%;">{{ __(key, ['titleCase']) }}:</td>
                                        <td v-html="format(value)"></td>
                                    </tr>
                                    <tr>
                                        <td class="text-left vert-top" valign="top">Comment:</td>
                                        <td>
                                            <address>
                                                {{ orderData.comment || '---' }}
                                            </address>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div v-if="uploadImage" class="panel panel-default">
                    <div class="panel-heading">
                        <h3 class="table-heading">Upload image</h3>
                    </div>
                    <div class="panel-body">
                        <div class="img-cont">
                        <img :src="_.imgPath(uploadImage)" class="w-100">
                        <p class="mt-2">{{ uploadImageName }}
                            <a :href="'/asset/' + _.get(uploadImage, 'id', 'null') + '?download'" target="_blank"
                                class="btn btn-primary btn-icon btn-rounded btn-sm float-right">
                                <i class="material-icons">get_app</i> DOWNLOAD IMAGE</a></p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    props: ['content'],

    mounted() {
        this.$emit('content::initialized', {
            type: this.content.type,
            name: 'order-detail-component',
            config: {},
        });
    },

    computed: {
        orderData() {
            return _.merge(this.content.attributes, this.content.meta);
        },

        customOrderData() {
            return _.get(this.content, 'attributes.order_data', {});
        },

        clientName() {
            const { firstname, lastname } = this.content.attributes;

            return `${firstname} ${lastname}`;
        },

        uploadImage() {
            const uploadFileId = _.get(this.content, 'attributes.upload_file', null);

            return uploadFileId;
        },

        uploadImageName() {
            return _.get(this.content, 'attributes.upload_file.name', null);
        },
    },

    methods: {
        format(value, field = null) {
            if (_.isArray(value)) {
                return _.map(value, this.format).join('<br>');
            }

            if (_.isObject(value)) {
                return _.toPairs(value)
                    .map(([key, val]) => `${_.format(key, ['titleCase'])}: ${this.format(val, key)}`)
                    .join('<br>');
            }

            switch (field) {
                case 'width':
                case 'height': return `${value}mm`;
                case 'quantity': return value;
                default: return value;
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/OrderDetailComponent.vue